export default __webpack_public_path__ + "static/media/Joao-Batista-de-Macedo.b7d0017d.png";